import React, { useState, useEffect } from 'react';
import { Bot } from 'lucide-react';
import { useDarkMode } from '../../darkmode/DarkModeContext';

const AIAssistantFloat = ({ navigate }) => {
  const { isDarkMode } = useDarkMode();
  const [isVisible, setIsVisible] = useState(false);

  // Show button after a short delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleChatbotRedirect = () => {
    navigate('/chatbot');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {/* Status Indicator */}
      <div 
        onClick={handleChatbotRedirect}
        className={`flex items-center gap-2 px-3 py-1.5 rounded-full cursor-pointer shadow-lg ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}
      >
        <span className="relative flex h-2 w-2">
          <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
        </span>
        <span className={`text-xs font-medium ${isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
          Layanan Online 24/7
        </span>
      </div>
    </div>
  );
};

export default AIAssistantFloat;